export const freqOptimizationEnabledByGoalType = (goalType) => {
  const excludedGoalTypes = ["spend", "reach"];
  return !excludedGoalTypes.includes(goalType);
};
